import useSWR from "swr";
import { getEntityTypes } from "./watch-list-service";
import { UseEntityTypesModel } from "./types";

const useEntityTypes = (): UseEntityTypesModel => {
  const { data, error, isLoading, mutate } = useSWR(`/entity-types`, () =>
    getEntityTypes(),
  );

  return {
    data: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useEntityTypes;
